<template>
  <div>
    <mt-header class="header" title="活动专区">
      <header-item slot="left" v-bind:isBack = true v-on:onclick="goBack">
      </header-item>    
    </mt-header> 
    <div class="refreshText"></div>
    <div class="discount-body">
      <div infinite-scroll-disabled="loading" infinite-scroll-distance="10" >
        <discount-body v-for="(item, index) in activitiesList" :index="index" :item="item" :key="index"></discount-body>
        <div class="wrapper-list-empty" v-if='activitiesList.length <= 0'>
        <div>
          <img src="../../assets/image/change-icon/empty_active@2x.png">
          <p>暂无优惠活动</p>
        </div>
      </div>
    </div>
	</div>
  </div>
</template>

<script>
import { HeaderItem } from '../../components/common'
import { Header } from 'mint-ui'

import DiscountBody from './child/DiscountBody';
import { activityList } from '../../api/activity'; //优惠活动列表

export default {
  components: {
    DiscountBody,
  },
  data() {
    return {
      activitiesList: [],
    };
  },
  created() {
    this.getActivityList();
  },
  mounted() {         
    // var _element = document.querySelector('.discount-body'),
    //     _refreshText = document.querySelector('.refreshText'),
    //     _startPos = 0,
    //     _transitionHeight = 0;
    //   _element.addEventListener('touchstart', function (e) {
    //     if(dom.scrollTop != 0) return false
    //     _startPos = e.touches[0].pageY;
    //     _element.style.position = 'relative';
    //     _element.style.transition = 'transform 0s';
    //   }, false);

    //   _element.addEventListener('touchmove', function (e) {
    //     if(_element.scrollTop != 0) return false
    //     _transitionHeight = e.touches[0].pageY - _startPos;
    //     if (_transitionHeight > 20 && _transitionHeight < 60) {
    //       _refreshText.innerText = '下拉刷新';
    //       _element.style.transform = 'translateY(' + _transitionHeight + 'px)';
    //       if (_transitionHeight > 55) {
    //         _refreshText.innerText = '释放更新';
    //       }
    //     }
    //   }, false);
    //   _element.addEventListener('touchend', function (e) {
    //     if(_element.scrollTop == 0 & _transitionHeight >20){
    //       _element.style.transition = 'transform 0.5s ease 1s';
    //       _element.style.transform = 'translateY(0px)';
    //       _refreshText.innerText = '更新中...';
    //       setTimeout(()=>{window.location.reload()},300);
    //     }
    //   }, false);
  },
  activated(){
    this.target = document.querySelector('.discount-body');
    this.target.addEventListener('scroll', (event) => {
      if (this.target.scrollTop) {
        this.offsetTop = this.target.scrollTop
      } 
    });
    if(this.offsetTop) this.target.scrollTop = this.offsetTop
  },
  methods: {  
    goBack() {
      this.$router.go(-1); 
    },
    // 获取订单列表
    getActivityList() {
      activityList().then(res => {
        if (res) {
          this.activitiesList = res.activities;
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.header {
  @include header;
  background-color: #ed8b19;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid $lineColor;
}
.discount-body {
  position: absolute;
  top: 44px;
  bottom: 0px;
  overflow-y: auto;
  width: 100%;
}
.wrapper-list-empty {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding-top: 40%;
  div {
  	display: flex;
  	flex-direction: column;
  	align-items: center;
  	img {
  		width: 75px;
  		height: 75px;
  	}
    p {
    	margin-top: 27px;
      text-align: center;
      color: #A4AAB3;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/page/discount/Discount.vue